/**
 * Created by Kim J on 2018-01-31.
 */
var DetailEligGOEAddFieldsController = (function () {
    function DetailEligGOEAddFieldsController(topic, $scope, socket) {
        var _this = this;
        this.topic = topic;
        this.$scope = $scope;
        this.socket = socket;
        this.comp = 'goe_add_fields';
        this.cutOver = this.topic.settings.generalDeterminationCutoverDate;
        this.isNewGoeDetermination = false; // new Goe Determination questions (cutover date: 18/02/2020)
        this.overallFindGOEResult = ['Government Owned Entity', 'State Owned Enterprise', 'Unknown', 'Non-Government', 'No Results Found'];
        this.overallGoeIndicator = ['Government Owned Entity', 'State Owned Enterprise', 'Unknown', 'Non-Government'];
        this.goeDeterminant = ['FindGOE Tool', 'Exception list', 'IntOrg list', 'DUNS tab check', 'PEP check', 'GOE Team', 'NGE Declaration Process', 'SO name Clarification'];
        this.declarationLetter = ['Yes', 'No'];
        this.uiVersion = this.topic.checksData.uiVersion;
        this.visibleGOEAddFields = false;
        this.$scope.$on('broadcast:topicUpdated', function (event, data) {
            if (data.indexOf(_this.comp) > -1) {
                _this.edit = _this.topic.getEditComponent(_this.comp);
            }
        });
        this.goe_decl_letter_sent = ['Yes', 'No'];
        this.goe_indicator = ['GE', 'Unknown', 'NGE'];
        this.goe_determinant = ['FindCMR tool', 'Exception list', 'Internet check', 'IntOrgList', 'BRET check', 'PEP check', 'GOE Team', '25%/75% rule', 'SME Protocol', 'NGE 10.3.4', 'SO name clarification'];
        this.goe_overall_find_cmr = ['8A GE', '8B Unknown', '8C NGE', '8D GE', '8E Unknown', '8F Unknown'];
    }
    DetailEligGOEAddFieldsController.prototype.$onInit = function () {
        this.edit = this.topic.getEditComponent(this.comp);
        if (this.checkDate()) {
            this.isNewGoeDetermination = true;
        }
    };
    DetailEligGOEAddFieldsController.prototype.checkDate = function () {
        return this.topic.compareDates(new Date(Number(this.topic.topic.gpp[0].svisubmitdate)), new Date(this.cutOver)) > 0;
    };
    DetailEligGOEAddFieldsController.prototype.changeEditMode = function (action) {
        if (action === 'save') {
            if (this.topic.updatePartialSocketStatus([this.comp], 'Updating')) {
                var updateObject = {
                    data: {
                        goe_add_fields: {
                            add: true,
                            data: this.topic.temp.goe_add_fields
                        }
                    },
                    id: this.topic.topic._id,
                    type: ['goe_add_fields']
                };
                this.topic.updateServerTopic('couchUpdate', updateObject, true);
                this.edit.editMode = this.topic.cancelEdit(this.comp);
            }
        }
        else if (action === 'edit') {
            this.edit.editMode = this.topic.setTempFromTopicPart(this.comp);
        }
        else {
            this.edit.editMode = this.topic.cancelEdit(this.comp);
        }
    };
    DetailEligGOEAddFieldsController.prototype.toggleGOEAddFields = function () {
        this.visibleGOEAddFields = !this.visibleGOEAddFields;
    };
    DetailEligGOEAddFieldsController.$inject = ['topic', '$scope', 'socket', 'env', '_'];
    return DetailEligGOEAddFieldsController;
}());
var DetailEligGOEAddFieldsComponent = (function () {
    function DetailEligGOEAddFieldsComponent() {
        this.templateUrl = 'detail-eligibility-goe-addfields.html';
        this.controllerAs = 'vm';
        this.controller = DetailEligGOEAddFieldsController;
    }
    return DetailEligGOEAddFieldsComponent;
}());
angular
    .module('application')
    .component('detailEligibilityGoeAddfields', new DetailEligGOEAddFieldsComponent());

//# sourceMappingURL=detail.goe.addfields.components.js.map
